export default __webpack_public_path__ + "static/media/CanonBig.33d20edb.gif";